module.exports = __webpack_public_path__ + "static/hero-lauv-d094407abdcee4242398742ea9e93646.jpg";